/**
 * 认证错误页的 query 参数约定。
 *
 * 独立放在 router 层是为了让守卫、页面和测试共享同一套字面量，
 * 避免不同文件手写字符串后出现分支无法命中的隐性错误。
 */

/** 认证错误原因在 URL query 中使用的字段名。 */
export const AUTH_ERROR_REASON_QUERY_KEY = 'reason';

/**
 * 认证错误页支持的原因集合。
 */
export const AUTH_ERROR_REASON = {
  /** 开发环境自动登录已经启用，但自动登录请求未能建立会话。 */
  DevAutoLoginFailed: 'dev-auto-login-failed',

  /** 外部登录地址没有通过环境变量显式配置。 */
  MissingExternalAuthConfig: 'missing-config',

  /** 外部登录地址格式无效，无法生成登录跳转地址。 */
  InvalidExternalAuthConfig: 'invalid-config',
} as const;

/** 认证错误页原因的联合类型。 */
export type AuthErrorReason = typeof AUTH_ERROR_REASON[keyof typeof AUTH_ERROR_REASON];
